import * as yup from 'yup'

import { EMAIL_REGEXP } from '../constants'
import i18n from '../i18n'

export const EmailInputSchema = yup.object().shape({
  email: yup
    .string()
    .required(i18n.t('auth.shared.validation.emailRequired') || '')
    .matches(EMAIL_REGEXP, i18n.t('auth.shared.validation.emailInvalid') || ''),
})
